import React from 'react';
export default ({ className, onClick, children }) => (React.createElement("div", { className: className, onClick: onClick }, children));
